export default "__VITE_ASSET__BswR1Uy1__"